<div class="employee-deetail-dialog" mat-dialog-content>
  <!-- LOADER -->
  <div class="view-container" *ngIf="doc">
    <mat-toolbar class="view-toolbar">
      <mat-toolbar-row>
        <!-- document-selected-header-info -->
        <div class="view-description">
          <mat-icon class="fa-lg" fontSet="fa" fontIcon="fa-file-certificate">
          </mat-icon>
          <div class="view-description-text" fxLayout="column" fxLayoutAlign="center start">
            <h3 matLine [title]="doc.name"> {{ 'fileDocuments.fileDocumentDetail.nom151EvidenceBtn' | transloco }} </h3>
            <h5 matLine> {{ 'common.idLbl' | transloco }}{{doc.id}} - {{ 'common.documentDateLbl' | transloco }}: {{ data.documentDate | date :'dd/MM/yyyy' }}</h5>
          </div>
        </div>
        <div class="view-actions">
          <div fxLayout="row" fxLayoutAlign="end center">
            <!-- PDF-controls -->
            <app-pdf-wrapper-controls [pdfWrapper]="pdfWrapper" [showPrint]="true" [showSave]="true"
              [showZoomIn]="filePdf" [showZoomOut]="filePdf">
            </app-pdf-wrapper-controls>

            <div class="divider-vert"></div>
            <!-- close-modal-only -->
            <button mat-icon-button (click)="dialogClose()" title="{{ 'common.closeBtn' | transloco }}">
              <mat-icon class="fa-lg" fontSet="fa" fontIcon="fa-times"></mat-icon>
            </button>
          </div>
        </div>
      </mat-toolbar-row>
    </mat-toolbar>
    <div class="view-content">
      <div class="pdf-view-container" fxFlex.lt-md="130" fxFlex.gt-sm="70" fxFill>
      <!-- PDF-viewer -->
       <app-pdf-wrapper [showControls]="false" [hideSignaturePanel]="true" #pdfWrapper [doc]="doc" [file]="filePdf" [fileName]="fileName"
      [autoView]="false">
      </app-pdf-wrapper>
       </div>
   </div>
 </div>
</div>
